import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/login'
import { useAuth } from 'react-oidc-context';
import { Spinner, Toast, ToastBody, Toaster, ToastTitle, useId, useToastController } from '@fluentui/react-components';
import Home from 'pages/home';
import Findings from 'pages/findings';
import { useEffect } from 'react';
import { useAuthEnvironmentGuard } from 'hooks/useAuthEnvironmentGuard';

// Routes/guard must live under BrowserRouter so the environment guard can
// use useLocation/useNavigate/useSearchParams.
function AppRoutes({ dispatchToast }: { dispatchToast: (content: React.ReactElement, options?: { intent?: 'success' | 'error' | 'warning' | 'info'; timeout?: number }) => void }) {
  const auth = useAuth();
  useAuthEnvironmentGuard();

  return (
    <Routes>
      <Route path="/" element={<Home dispatchToast={dispatchToast} />} />
      <Route path="/findings" element={<Findings token={auth.user?.access_token} />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

function App() {

  const auth = useAuth();
  const toasterId = useId();
  const { dispatchToast } = useToastController(toasterId);

  useEffect(() => {
    if (auth.error) {
      const errorMsg = auth.error.message || 'Authentication failed';
      
        dispatchToast(
          <Toast>
            <ToastTitle>Login Failed</ToastTitle>
            <ToastBody>{errorMsg}</ToastBody>        
          </Toast>,
          { intent: "error", timeout: 3000 }
       );
    }
  }, [auth.error, dispatchToast]);

  auth.events.addAccessTokenExpiring(() => {
    auth.signinSilent().then(user => {
      console.log('signinSilent finished', user);
      //this is where I reset auth token for http headers because it is being stored.
    }).catch(error => {
      console.log('signinSilent failed', error);
    });
  });

  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <Spinner appearance="primary" label="Loading..." />;
  }
  return (
    <>
    <Toaster toasterId={toasterId} />      
    <BrowserRouter>
      <AppRoutes dispatchToast={dispatchToast} />
    </BrowserRouter>
    </>
  );
}

export default App;
